import { FunctionComponent } from "react";

import {
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  useTheme
} from "@bps/fluent-ui";
import { ServerMigrationFieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { ServerMigrationGuid } from "./ServerMigrationGuid";
import { ServerMigrationLabeledText } from "./ServerMigrationLabeledText";

interface ServerMigrationDeviceCardProps {
  title: string;
  device?: ServerMigrationFieldDevice;
}

export const ServerMigrationDeviceCard: FunctionComponent<ServerMigrationDeviceCardProps> = ({
  title,
  device
}) => {
  const theme = useTheme();

  return (
    <Stack
      grow
      tokens={{ childrenGap: theme.spacing.s1, padding: theme.spacing.m }}
      styles={{
        root: {
          flexBasis: 0,
          minWidth: 0,
          border: `1px solid ${theme.palette.neutralLight}`,
          borderRadius: 4
        }
      }}
    >
      <Text variant="mediumPlus">{title}</Text>
      {device ? (
        <Stack tokens={{ childrenGap: theme.spacing.s2 }}>
          <ServerMigrationLabeledText label="Computer name" labelWidth={110}>
            {device.computerName}
          </ServerMigrationLabeledText>
          <ServerMigrationLabeledText label="Field device" labelWidth={110}>
            <ServerMigrationGuid value={device.id} />
          </ServerMigrationLabeledText>
          <ServerMigrationLabeledText label="Site name" labelWidth={110}>
            {device.siteName}
          </ServerMigrationLabeledText>
          <ServerMigrationLabeledText label="Site id" labelWidth={110}>
            {device.siteId}
          </ServerMigrationLabeledText>
          <ServerMigrationLabeledText label="Status" labelWidth={110}>
            <TextBadge
              badgeSize={TextBadgeSize.small}
              badgeColor={
                device.isActive ? TextBadgeColor.green : TextBadgeColor.red
              }
              styles={{ root: { width: "fit-content" } }}
            >
              {device.isActive ? "Active" : "Inactive"}
            </TextBadge>
          </ServerMigrationLabeledText>
        </Stack>
      ) : (
        <Text>No field device details were returned.</Text>
      )}
    </Stack>
  );
};
